import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { contract } from "my-hr/configs/my-hr-info-card-defs";
import { OcInfoCard, OcPageTransition } from "oc/components";

interface Contract {
  code: string;
  jobClass?: {
    name: string;
  };
  employmentType?: {
    code: string;
  };
  // Add other fields as needed
}

interface MyHrContractsDataPanelProps {
  contracts: Contract[];
}

export const MyHrContractsDataPanel: React.FC<MyHrContractsDataPanelProps> = ({
  contracts,
}) => {
  const { t } = useTranslation();
  return (
    <OcPageTransition>
      <>
        {contracts?.map((item, index) => {
          let label = item?.jobClass?.name
            ? item.jobClass.name.charAt(0).toUpperCase() +
              item.jobClass.name.slice(1)
            : "";

          if (
            item?.employmentType?.code === "5" ||
            item?.employmentType?.code === "6"
          ) {
            label = t("MY_HR_CONTRACT_OF_SERVICES");
          }
          return (
            <Box
              key={`${item.code}-${index}`}
              marginBottom={index < contracts?.length - 1 ? "16px" : "0px"}
            >
              <OcInfoCard def={contract} data={item} label={label} />
            </Box>
          );
        })}
      </>
    </OcPageTransition>
  );
};

export default MyHrContractsDataPanel;
